import {
  FirstLoanOfferQueryParams,
  FirstLoanOfferResponse,
} from 'api/typegen/application/first-loan-offer/get';
import { QueryStatus, useQuery } from '@tanstack/react-query';
import getFirstLoanOfferApiCall from 'api/calls/getFirstLoanOfferApiCall';

interface UseFirstLoanOfferQuery {
  status: QueryStatus;
  firstLoanOffer?: FirstLoanOfferResponse;
}

const useFirstLoanOfferQuery = (
  amount: number,
  term?: number,
): UseFirstLoanOfferQuery => {
  const query = useQuery(
    ['firstLoanOffer', { amount, term }],
    ({ queryKey }) =>
      getFirstLoanOfferApiCall({
        ...(queryKey[1] as FirstLoanOfferQueryParams),
      }),
    {
      enabled: amount > 0 && Boolean(term),
      staleTime: Infinity,
    },
  );

  return {
    status: query.status,
    firstLoanOffer: query.data,
  };
};

export default useFirstLoanOfferQuery;
